export default {
    url: '/questioncategories',
    template: '<ui-view></ui-view>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/settings/questioncategories/index.js